import { apiSlice } from "../apiSlice";
import {
  AvailabilityStatus,
  CreateMenuItem,
  FilterTagsResponse,
  GetAllergenInformationResponse,
  GetFoodAttributesListResponse,
  GetMenuItemsResponse,
  UpdateMenuItemAvailabilityRequest,
} from "../menuSlice";
import {
  LogoFileExtntionRequest,
  LogoFileExtntionResponse,
  UpdateImageRequest,
} from "../../views/Profile/AddRestaurant";

const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_PROD;

// Types for organizations
export interface Organization {
  organizationId: string;
  displayName: string;
  code: string;
  status: "Approved" | "Pending" | "Rejected";
  createdAt: {
    _seconds: number;
    _nanoseconds: number;
  };
  updatedAt: {
    _seconds: number;
    _nanoseconds: number;
  };
  supportsDeliveryPoint: boolean;
  deliveryPoint?: {
    deliveryAddress: string;
    deliveryLatitude: number;
    deliveryLongitude: number;
    deliveryContactName: string;
    deliveryContactPhone: string;
  };
  creditSettings: {
    creditTermsDays: number;
    allowCreditOrders: boolean;
    memberDefaultLimit: number;
  };
  walletData: {
    creditLimit: number;
    balance: number;
    currentOutstanding: number;
  };
}

export type GetAllOrganizationsResponse = Organization[];

export const menuItemService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createMenuItem: builder.mutation<string, CreateMenuItem>({
      query: (data) => ({
        url: `https://adminhttps-createmenuitem${API_BASE_DOMAIN}/`,
        method: "POST",
        body: data,
        responseHandler: (response) => response.text(),
      }),
    }),

    getMenuItemsByRestaurantId: builder.query<GetMenuItemsResponse, string>({
      query: (restaurantId) => ({
        url: `https://adminhttps-getmenuitemsbyrestaurantid${API_BASE_DOMAIN}?restId=${restaurantId}`,
        method: "GET",
      }),
    }),

    updateMenuItem: builder.mutation<any, { data: any }>({
      query: ({ data }) => ({
        url: `https://adminhttps-updatemenuitem${API_BASE_DOMAIN}`,
        method: "PUT",
        body: data,
        responseHandler: (response) => response.text(),
      }),
    }),

    deleteMenuItem: builder.mutation<void, { menuId: string; restId: string }>({
      query: ({ menuId, restId }) => ({
        url: `https://adminhttps-deletemenuitem${API_BASE_DOMAIN}/?menuId=${menuId}&restId=${restId}`,
        method: "GET",
        responseHandler: (response) => response.text(),
      }),
    }),

    UploadMenuItemLogoFileExtntionHttps: builder.mutation<
      LogoFileExtntionResponse,
      LogoFileExtntionRequest
    >({
      query: (data) => ({
        url: `https://adminhttps-getmenuitemimageuploadurl${API_BASE_DOMAIN}/`,
        method: "POST",
        body: data,
      }),
    }),

    UpdateMenuItemImages: builder.mutation<string, UpdateImageRequest>({
      query: (data) => ({
        url: `https://adminhttps-updatemenuitemimage${API_BASE_DOMAIN}/`,
        method: "POST",
        body: data,
        responseHandler: (response) => response.text(),
      }),
    }),

    updateAvailabilityStatus: builder.mutation<string, AvailabilityStatus>({
      query: (data) => ({
        url: `https://adminhttps-updateisavailablestatus${API_BASE_DOMAIN}/`,
        method: "POST",
        body: data,
        responseHandler: (response) => response.text(),
      }),
    }),

    updateMenuItemAvailability: builder.mutation<
      string,
      UpdateMenuItemAvailabilityRequest
    >({
      query: (data) => ({
        url: `https://adminhttps-updatemenuitemavailability${API_BASE_DOMAIN}`,
        method: "POST",
        body: data,
        responseHandler: (response) => response.text(),
      }),
    }),
    
    getAllergenInformation: builder.query<GetAllergenInformationResponse, void>({
      query: () => ({
        url: `https://adminhttps-getallergeninformation${API_BASE_DOMAIN}/`,
        method: "GET",
      }),
    }),

    getFoodAttributesList: builder.query<GetFoodAttributesListResponse, void>({
      query: () => ({
        url: `https://adminhttps-getfoodattributeslist${API_BASE_DOMAIN}/`,
        method: "GET",
      }),
    }),
    
    getRestaurantFilterTags: builder.query<FilterTagsResponse, string>({
      query: (restaurantId) => ({
        url: `https://userhttps-getrestaurantfiltertags${API_BASE_DOMAIN}?restaurantId=${restaurantId}`,
        method: "GET",
      }),
    }),

    // New organization endpoints
    getAllOrganizations: builder.query<GetAllOrganizationsResponse, void>({
      query: () => ({
        url: `https://adminhttps-getallorganizations${API_BASE_DOMAIN}/`,
        method: "GET",
      }),
    }),

  
  }),
});

export const {
  useCreateMenuItemMutation,
  useGetMenuItemsByRestaurantIdQuery,
  useLazyGetMenuItemsByRestaurantIdQuery,
  useUpdateMenuItemMutation,
  useDeleteMenuItemMutation,
  useUploadMenuItemLogoFileExtntionHttpsMutation,
  useUpdateMenuItemImagesMutation,
  useUpdateAvailabilityStatusMutation,
  useUpdateMenuItemAvailabilityMutation,
  useGetAllergenInformationQuery,
  useLazyGetAllergenInformationQuery,
  useGetFoodAttributesListQuery,
  useLazyGetFoodAttributesListQuery,
  useLazyGetRestaurantFilterTagsQuery,
  useGetAllOrganizationsQuery,
  useLazyGetAllOrganizationsQuery,

} = menuItemService;